import { useEffect, useRef } from 'react';
import { statusAPI } from '../lib/api';

const useOnlineStatus = () => {
  const intervalRef = useRef(null);

  useEffect(() => {
    const token = localStorage.getItem('token');
    if (!token) return;

    // Send heartbeat immediately
    statusAPI.heartbeat().catch(() => {});

    // Send heartbeat every 30 seconds
    intervalRef.current = setInterval(() => {
      statusAPI.heartbeat().catch(() => {});
    }, 30000);

    // Set offline on page unload
    const handleUnload = () => {
      navigator.sendBeacon && statusAPI.setOffline().catch(() => {});
    };
    window.addEventListener('beforeunload', handleUnload);

    return () => {
      if (intervalRef.current) clearInterval(intervalRef.current);
      window.removeEventListener('beforeunload', handleUnload);
      statusAPI.setOffline().catch(() => {});
    };
  }, []);
};

export default useOnlineStatus;
